import React, { useState } from "react";
import { FaCircleCheck, FaCartShopping } from "react-icons/fa6";
import { Container } from "../home/ui";

// Left artwork (product card mock-up). Put the file at public/img/ecommerce-features.jpg
// (or change the path). Until it exists, a simple gradient placeholder is shown.
const featuresImg = "/img/ecommerce-features.jpg";

const features = [
  "Product Catalog Management",
  "Customer Accounts & Wishlist",
  "Advanced Search & Filters",
  "Discounts, Coupons & Offers",
  "Multiple Payment Gateways",
  "Multi-language & Multi-currency",
  "Order & Inventory Management",
  "Analytics & Reporting",
  "Shipping & Tax Integration",
  "Mobile Responsive Design",
];

const EcomFeatures = () => {
  const [failed, setFailed] = useState(false);

  return (
    <section className="bg-white py-[40px] lg:py-[56px]">
      <Container className="max-w-[1320px]">
        <div className="grid items-center gap-[36px] lg:grid-cols-[minmax(0,0.85fr)_minmax(0,1.15fr)] lg:gap-[48px]">
          <div className="flex justify-center">
            {failed ? (
              <div className="flex aspect-[4/3] w-full max-w-[520px] items-center justify-center rounded-[28px] bg-gradient-to-br from-[#E9E6FF] to-[#F3EEFF] text-[80px] text-[#7C5CF5]">
                <FaCartShopping />
              </div>
            ) : (
              <img
                src={featuresImg}
                onError={() => setFailed(true)}
                alt="E-commerce product page with rating and add to cart button"
                className="h-auto w-full max-w-[560px] select-none object-contain"
              />
            )}
          </div>

          <div>
            <h2 className="text-[30px] font-bold leading-[1.2] tracking-tight text-[#0B0D2C] sm:text-[36px] xl:text-[40px]">
              Features of Our
              <br />
              E-commerce <span className="text-[#7C2CF0]">Websites</span>
            </h2>
            <p className="mt-[12px] max-w-[520px] text-[15px] leading-[1.6] text-slate-600 sm:text-[16px]">
              We include all the essential features and more to give your customers a smooth and secure shopping
              experience.
            </p>
            <ul className="mt-[24px] grid gap-x-[32px] gap-y-[18px] sm:grid-cols-2">
              {features.map((f) => (
                <li key={f} className="flex items-center gap-[12px] text-[15px] text-[#1F2547]">
                  <FaCircleCheck className="shrink-0 text-[20px] text-[#8B5CF6]" />
                  {f}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default EcomFeatures;
